// Lingue originali dei discorsi (nome in italiano).
export const LANGUAGES = [
  "Inglese",
  "Italiano",
  "Francese",
  "Tedesco",
  "Spagnolo",
  "Portoghese",
  "Russo",
  "Ucraino",
  "Cinese",
  "Giapponese",
  "Coreano",
  "Arabo",
  "Ebraico",
  "Turco",
  "Persiano (Farsi)",
  "Hindi",
  "Olandese",
  "Polacco",
  "Greco",
  "Svedese",
  "Norvegese",
  "Danese",
  "Finlandese",
  "Ceco",
  "Ungherese",
  "Rumeno",
  "Bulgaro",
  "Serbo",
  "Croato",
  "Altra lingua",
];
